import script from "./PaginatorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginatorComponent.vue?vue&type=script&setup=true&lang=js"

import "./PaginatorComponent.vue?vue&type=style&index=0&id=76cf0553&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76cf0553"]])

export default __exports__